import { create } from "zustand";
import { persist } from "zustand/middleware";

interface SessionState {
  accessToken: string | null;
  refreshToken: string | null;
  expiresIn: number | null;
  userInfo: Record<string, unknown> | null;
  /**
   * Gate OTP post-login : `false` après chaque `loginWithPassword` tant que
   * l'utilisateur n'a pas validé le code OTP envoyé sur son e-mail. Un refresh
   * de token préserve la valeur ; `clearSession` la ramène à `false`.
   */
  otpVerified: boolean;
  setSession: (
    s: Partial<
      Omit<
        SessionState,
        "setSession" | "clearSession" | "setOtpVerified"
      >
    >
  ) => void;
  setOtpVerified: (value: boolean) => void;
  clearSession: () => void;
}

export const useSessionStore = create<SessionState>()(
  persist(
    (set) => ({
      accessToken: null,
      refreshToken: null,
      expiresIn: null,
      userInfo: null,
      otpVerified: false,
      setSession: (s) => set(s),
      setOtpVerified: (value) => set({ otpVerified: value }),
      clearSession: () =>
        set({
          accessToken: null,
          refreshToken: null,
          expiresIn: null,
          userInfo: null,
          otpVerified: false,
        }),
    }),
    { name: "flash-pay-session" }
  )
);
